<template>
  <div v-if="attachment" class="mr-3">
    <VBtn id="new_document" class="my-3 v-btn--block" color="primary" @click="markFirstPage">
      Loči nov dokument na trenutni strani
    </VBtn>
    <div style="height: 70vh">
      <Viewer
        id="viewer"
        :file="attachment.file"
        :fileName="attachment.file_name"
        :mailFrom="attachment.received_mail.from_mail"
        :mailSubject="attachment.received_mail.subject"
        :mailDate="attachment.received_mail.sent_date"
        @current-page="setCurrentPage"
        @num-pages="numPagesChange"
      ></Viewer>
    </div>
  </div>
</template>

<script>
import Viewer from '@/components/preview/Viewer.vue';

export default {
  name: 'PdfSplitter',
  components: { Viewer },
  props: {
    attachment: {
      type: Object,
      default: null,
    },
    selectedPageNumber: {
      type: Number,
      default: 0,
    },
    splitDocument: {
      type: Object,
      default: () => ({
        first: 1,
        last: null,
      }),
    },
  },
  data() {
    return {
      rotation: 0,
      pageNum: 1,
      numPages: 1,
      currentDocument: {
        first: 1,
        last: null,
      },
    };
  },
  watch: {
    selectedPageNumber(value) {
      this.pageNum = value;
    },
    splitDocument(value) {
      this.currentDocument = value;
    },
    attachment() {
      this.$store.dispatch('deleteAllDocuments');
    },
  },
  methods: {
    markFirstPage() {
      if (this.pageNum - 1 === 0) return;
      this.currentDocument.last = this.pageNum - 1;
      const newPageObject = this._.cloneDeep(this.currentDocument);
      if (newPageObject.first > newPageObject.last) {
        const tmp = newPageObject.last;
        newPageObject.last = newPageObject.first;
        newPageObject.first = tmp;
      }
      if (newPageObject.first > this.numPages) {
        newPageObject.first = this.numPages;
      }
      if (newPageObject.last > this.numPages) {
        newPageObject.last = this.numPages;
      }
      this.currentDocument = {
        first: this.pageNum,
        last: null,
      };
      this.$store.dispatch('addNewDocument', newPageObject);
    },
    setCurrentPage(event) {
      this.pageNum = event;
      this.$emit('page-num', this.pageNum);
    },
    numPagesChange(event) {
      if (event) {
        this.numPages = event;
        this.pageNum = 1;
        this.$emit('num-pages', event);
        this.currentDocument = {
          first: 1,
          last: null,
        };
        this.addInitialDocument(event);
      }
    },
    addInitialDocument(numPages) {
      const initialDocument = {
        first: this.pageNum,
        last: numPages,
      };
      this.$store.dispatch('addInitialDocument', initialDocument);
    },
  },
};
</script>

<style scoped></style>
